// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__3OEpi","background":"styles_background__Nq61h","lines":"styles_lines__1EGS2"};